import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import 'prop-types';
import classnames from 'classnames';
const namespace = 'ui-pdp-title';
const Title = _ref => {
  let {
    className = '',
    title
  } = _ref;
  return /*#__PURE__*/_jsx("h1", {
    className: classnames(namespace, className)
  }, void 0, title);
};
export { Title };
